(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
    (() => {
    const path = window.location.pathname.replace(/\/$/, '');
    if (!/\/collections\/(pokemon|one-piece)$/.test(path)) return;

    const previousProducts = new WeakMap();

    function shuffleProducts() {
      const params = new URLSearchParams(window.location.search);
      if (params.has('sort_by')) return;

      document.querySelectorAll('results-list').forEach((results) => {
        const firstCard = results.querySelector(
          'li.product-grid__item[data-product-id]'
        );
        if (!firstCard) return;

        const grid = firstCard.parentElement;
        const cards = Array.from(grid.children).filter((element) =>
          element.matches('li.product-grid__item[data-product-id]')
        );
        if (cards.length < 2) return;

        const signature = cards
          .map((card) => card.dataset.productId)
          .sort()
          .join(',');

        if (previousProducts.get(grid) === signature) return;
        previousProducts.set(grid, signature);

        for (let i = cards.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [cards[i], cards[j]] = [cards[j], cards[i]];
        }

        const slots = Array.from(grid.childNodes);
        const fragment = document.createDocumentFragment();
        let index = 0;

        slots.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.matches('li.product-grid__item[data-product-id]')
          ) {
            fragment.appendChild(cards[index++]);
          } else {
            fragment.appendChild(node);
          }
        });

        grid.appendChild(fragment);
      });
    }

    function start() {
      shuffleProducts();

      let scheduled = false;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;

        requestAnimationFrame(() => {
          scheduled = false;
          shuffleProducts();
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();


  } catch(e) { console.error(e); }
})();
})();
